var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.9 76.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.9px;}.cls-3{fill:#018b9d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Boost") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timeline"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.45,
    cy: 38.45,
    r: 32.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.45,
    cy: 38.45,
    r: 38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.64,28.5c-.47-2.77-.45-2.61-.45-2.7,0-.41.25-.4,2.06-2.24a1.81,1.81,0,0,0-1-3.09l-2.62-.38a.56.56,0,0,1-.42-.3L40,17.41a1.81,1.81,0,0,0-3.25,0l-1.17,2.37a.61.61,0,0,1-.5.32.63.63,0,0,0,.18,1.24h.08a1.81,1.81,0,0,0,1.36-1L37.92,18a.56.56,0,0,1,1,0l1.17,2.37a1.81,1.81,0,0,0,1.36,1l2.62.38a.55.55,0,0,1,.31.95L42.48,24.5a1.82,1.82,0,0,0-.52,1.6c.47,2.73.46,2.62.46,2.71a.56.56,0,0,1-.82.48l-2.34-1.23a1.84,1.84,0,0,0-1.69,0L35.24,29.3a.56.56,0,0,1-.81-.48c0-.09,0,0,.46-2.71a1.82,1.82,0,0,0-.52-1.6l-1.89-1.85a.55.55,0,0,1,.31-.95h.05a.63.63,0,0,0-.18-1.24h-.05a1.81,1.81,0,0,0-1,3.09c1.86,1.89,2.13,1.87,2.05,2.34a29.53,29.53,0,0,0-.47,2.92,1.81,1.81,0,0,0,2.65,1.59l2.34-1.23a.57.57,0,0,1,.52,0c2.19,1.09,2.45,1.44,3.18,1.44a1.81,1.81,0,0,0,1.78-2.12Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.42,31.29a.63.63,0,0,0-.63.63V58.4a.63.63,0,0,0,1.26,0V31.92a.63.63,0,0,0-.63-.63Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59,36.66l-.79-1,.41-1.24A1.22,1.22,0,0,0,57,32.84l-1.23.42-1-.78a1.22,1.22,0,0,0-1.95,1l0,1.3-1.06.76a1.22,1.22,0,0,0,.35,2.16l1.25.38.39,1.24a1.22,1.22,0,0,0,2.16.33l.75-1.07H58a1.22,1.22,0,0,0,1-2Zm-2.3.69a1.22,1.22,0,0,0-1,.52l-.72,1-.38-1.19a1.22,1.22,0,0,0-.81-.8l-1.2-.37,1-.73a1.22,1.22,0,0,0,.51-1l0-1.25,1,.74a1.22,1.22,0,0,0,1.12.17L57.37,34,57,35.24a1.22,1.22,0,0,0,.18,1.12l.75,1Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.56,40a.63.63,0,1,0-.77-1,22.9,22.9,0,0,0-7.6,10.81,32.78,32.78,0,0,0-1.66,8.4.63.63,0,0,0,1.15.5,2,2,0,0,0,.15-.85C44.66,48,49,42.72,52.56,40Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.81,49.06a10.38,10.38,0,0,0-8,4.92A13.26,13.26,0,0,0,47,58.29a.63.63,0,0,0,1.23.23,12.11,12.11,0,0,1,1.61-3.86,9,9,0,0,1,7-4.35.63.63,0,0,0-.12-1.25Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.54,32.76A2.48,2.48,0,1,0,47,30.28a2.48,2.48,0,0,0-2.48,2.48ZM47,31.54a1.22,1.22,0,1,1-1.22,1.22A1.22,1.22,0,0,1,47,31.54Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.22,41.5A2.48,2.48,0,1,0,57.7,44a2.48,2.48,0,0,0-2.48-2.48Zm0,3.7A1.22,1.22,0,1,1,56.44,44a1.22,1.22,0,0,1-1.22,1.22Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.52,29.47a.63.63,0,0,0,.87-.16L54,26.93a.63.63,0,1,0-1-.71L51.36,28.6a.63.63,0,0,0,.16.87Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.09,25a.63.63,0,0,0,.61-.47l.73-2.8a.63.63,0,0,0-1.21-.32l-.73,2.8a.63.63,0,0,0,.61.79Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.4,22.48l2.37-1.67a.63.63,0,0,0-.72-1l-2.37,1.67a.63.63,0,0,0,.72,1Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.82,39.67A1.22,1.22,0,0,0,22,39.34l.39-1.24,1.25-.38A1.22,1.22,0,0,0,24,35.55l-1.06-.76,0-1.3a1.22,1.22,0,0,0-1.95-1l-1,.78-1.23-.42a1.22,1.22,0,0,0-1.55,1.54l.41,1.24-.79,1a1.22,1.22,0,0,0,1,2h1.3Zm-2-2.31.75-1a1.22,1.22,0,0,0,.18-1.12L18.36,34l1.18.41a1.22,1.22,0,0,0,1.12-.17l1-.74,0,1.25a1.22,1.22,0,0,0,.51,1l1,.73L22,36.9a1.22,1.22,0,0,0-.81.8l-.38,1.19-.72-1c-.55-.79-1.42-.43-2.26-.51Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.53,49.81A22.9,22.9,0,0,0,23.94,39a.63.63,0,1,0-.77,1C32,46.83,31.68,58,32.05,58.71a.63.63,0,0,0,1.15-.5,32.81,32.81,0,0,0-1.66-8.4Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.9,54a10.37,10.37,0,0,0-8-4.92.63.63,0,0,0-.12,1.25,9,9,0,0,1,7,4.31,12.21,12.21,0,0,1,1.64,3.89.63.63,0,0,0,1.23-.23A13.26,13.26,0,0,0,26.9,54Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.24,32.76a2.48,2.48,0,1,0,2.48-2.48,2.48,2.48,0,0,0-2.48,2.48Zm2.48-1.22a1.22,1.22,0,1,1-1.22,1.22,1.22,1.22,0,0,1,1.22-1.22Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.51,46.45A2.48,2.48,0,1,0,18,44a2.48,2.48,0,0,0,2.48,2.48Zm0-3.7A1.22,1.22,0,1,1,19.29,44a1.22,1.22,0,0,1,1.22-1.22Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.86,26.05a.63.63,0,0,0-.16.87l1.64,2.39a.63.63,0,1,0,1-.71l-1.64-2.39a.63.63,0,0,0-.87-.16Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26,24.55a.63.63,0,1,0,1.22-.32l-.73-2.8a.63.63,0,1,0-1.21.32Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19,20.81c2.41,1.65,2.38,1.78,2.73,1.78a.63.63,0,0,0,.36-1.14l-2.37-1.67a.63.63,0,0,0-.72,1Zm0,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/Boost.9d7c10a9469e2b37dbe0b286c54d786c.svg";
export { ForwardRef as ReactComponent };